import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  addDayOffFailure,
  addDayOffSuccess,
  deleteDayOffFailure,
  deleteDayOffSuccess,
  fetchAvailFailure,
  fetchAvailSuccess,
} from "./actions";
import { DELETE_DAYOFF, FETCH_AVAIL, ADD_DAYOFF } from "./constants";

export function* fetchAvailSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/day-off/list?${query}`);
    yield put(fetchAvailSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchAvailFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching list!"));
  }
}

export function* addAvailSaga({ payload, onAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).post, `/api/day-off/add`, payload);
    yield put(addDayOffSuccess(data));
    typeof onAdd === "function" && onAdd(data);
  } catch (e) {
    yield put(addDayOffFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteAvailSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/day-off/${payload}`);
    if (data) {
      yield put(deleteDayOffSuccess());
      typeof onDelete === "function" && onDelete(payload);
    }
  } catch (e) {
    yield put(deleteDayOffFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchAvailFlow() {
  yield takeEvery(FETCH_AVAIL, fetchAvailSaga);
}
export function* deleteAvailFlow() {
  yield takeEvery(DELETE_DAYOFF, deleteAvailSaga);
}
export function* addAvailFlow() {
  yield takeEvery(ADD_DAYOFF, addAvailSaga);
}

export default function* AvailabilitySaga() {
  yield all([fetchAvailFlow(), deleteAvailFlow(), addAvailFlow()]);
}
